module.exports = __webpack_public_path__ + "static/media/pryde-white.87aed10b.png";